import { Loader2 } from 'lucide-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/lib/auth-context';

/**
 * Route guard.
 *
 * Convenience only — every admin endpoint is protected server-side by
 * `JwtAuthGuard` and `PermissionsGuard`. Its job is to avoid rendering a screen
 * that would only fill with 401s, and to send the user back where they were
 * once they sign in.
 */
export function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();

  // The initial refresh is still settling; redirecting now would bounce a
  // signed-in user to the login page on every page load.
  if (loading) {
    return (
      <div className="grid min-h-dvh place-items-center bg-canvas">
        <Loader2 className="size-6 animate-spin text-ink-subtle" aria-label="Loading" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
